import { NamedGroopitFilterDisplayDTO } from "groopit-js/client";
import {
  SavedFiltersActions,
  SavedFiltersAddActionType,
  SavedFiltersDeleteActionType,
  SavedFiltersReplaceActionType,
  SavedFiltersUpdateActionType,
} from "./SavedFiltersActions";

export function SavedFiltersCollectionReducer(
  state: NamedGroopitFilterDisplayDTO[] | undefined,
  action: SavedFiltersActions,
): NamedGroopitFilterDisplayDTO[] | undefined {
  let newState: NamedGroopitFilterDisplayDTO[];

  switch (action.type) {
    case SavedFiltersAddActionType: {
      newState = [...(state ?? []), action.filter];
      break;
    }
    case SavedFiltersUpdateActionType: {
      newState = (state ?? []).map((filter) =>
        filter.id === action.filter.id ? action.filter : filter,
      );
      break;
    }
    case SavedFiltersDeleteActionType: {
      newState = (state ?? []).filter(
        (filter) => filter.id !== action.filterId,
      );
      break;
    }
    case SavedFiltersReplaceActionType: {
      newState = [...action.filters];
      break;
    }
  }

  newState.sort((a, b) => a.name.localeCompare(b.name));

  return newState;
}
